module.exports = __webpack_public_path__ + "img/david.a583bb51.svg";